import { baseFetch, getUrlWithSearchParams } from "@helium10/re-core";
import { apiALaCarteDowngrade, apiALaCarteUpdate, apiSubscribeProcess } from "../consts/links";
export const subscribeProcess = async (params, signal) => {
    const paymentIntentId = params?.paymentIntentId;
    const setupIntent = params?.setupIntent;
    const { [params?.type]: aLaCarteLink } = {
        updateModal: apiALaCarteUpdate,
        downgradeModal: apiALaCarteDowngrade,
    };
    // return mockSubscribeProcess;
    return await baseFetch({
        url: getUrlWithSearchParams(aLaCarteLink ?? apiSubscribeProcess, {}),
        withCredentials: true,
        method: "POST",
        params: {
            ...(paymentIntentId && { paymentIntentId: JSON.stringify(params?.paymentIntentId) }),
            ...(setupIntent && { setupIntent: JSON.stringify(params?.setupIntent) }),
            ...(params?.period && { period: params?.period }),
            ...(params?.type === "downgradeModal"
                ? {
                    planId: params?.plan ?? "",
                }
                : {
                    plan: params?.plan ?? "",
                }),
            captchaTokenV3: params?.captchaTokenV3 ?? "",
            name: params?.name ?? "",
            email: params?.email ?? "",
            coupon: params?.coupon ?? "",
            items: JSON.stringify(params?.items),
            "address[country]": params?.country ?? "",
            "address[street]": params?.street ?? "",
            "address[city]": params?.city ?? "",
            "address[state]": params?.state ?? "",
            "address[zip]": params?.zip ?? "",
        },
        signal,
    });
};
